// src/Pages/Usuario/Agenda/components/ServicioSelector.jsx
import React from "react";
import Select from "react-select";

export default function ServicioSelector({
  form,
  setForm,
  servicios,
  parsed,
  opcionesServicios,
  opcionesVariantes,
  modalidadKine,
  setModalidadKine,
  esKine1Sesion,
  errorServicio,
  selectStyles,
  planEntrada,
  setPlanEntrada,
  preseleccionarServicioDesdePlan,
  normModalidadUI,
  setPrimarySlot,
}) {
   const handleServicio = (op) => {
     // El horario elegido corresponde al servicio/modalidad anterior.
     setPrimarySlot?.(null);
     if (op?.isPlan) {
       setForm((prev) => ({ ...prev, hora: null, bloqueSeleccionado: null }));
       const p = op.planData;
       if (!p) return;
  
       setPlanEntrada?.(p);
  
       if (p?.modalidad && normModalidadUI) {
         setModalidadKine(normModalidadUI(p.modalidad));
       }
  
       preseleccionarServicioDesdePlan?.(p);
       return;
     }
  
     setPlanEntrada?.(null);
     setForm((prev) => ({
       ...prev,
       servicio: op,
       variante: null,
       hora: null,
       bloqueSeleccionado: null,
     }));
   };

  const handleVariante = (op) => {
    setPrimarySlot?.(null);
    setForm((prev) => ({
      ...prev,
      variante: op,
      hora: null,
      bloqueSeleccionado: null,
    }));
  };

  const opcionesVariantesUX =
    opcionesVariantes.map((v) => ({
      ...v,
      label: v.label.split(":")[0].trim(),
    }));

  const modalidadesPermitidas =
  form.variante?.data?.modalidadesPermitidas || {
    privada: true,
    grupal: false,
  };

  const permitePrivada =
    modalidadesPermitidas.privada;

  const permiteGrupal =
    modalidadesPermitidas.grupal;

React.useEffect(() => {

 if(!form.variante) return;

 const total =
 Number(permitePrivada) +
 Number(permiteGrupal);

 if(total!==1) return;

 const modalidadNueva =
 permitePrivada
 ? "privada"
 : "grupal";

 if(modalidadNueva===modalidadKine)
 return;

 setPrimarySlot?.(null);
 setModalidadKine(
 modalidadNueva
 );

 setForm(prev => ({

 ...prev,

 hora:null,
 bloqueSeleccionado:null,

 }));

},[
 form.variante,
 permitePrivada,
 permiteGrupal,
 modalidadKine,
 setModalidadKine,
 setForm,
 setPrimarySlot,
]);

  return (
    <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-[0_18px_50px_-22px_rgba(58,106,255,0.35)] border border-blue-100 overflow-hidden mt-6">
      {/* ENCABEZADO */}
      <div className="px-5 py-4 bg-blue-50/40 border-b border-blue-100 flex items-center gap-3">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#00698F] text-white font-bold">
          2
        </span>
        <span className="font-semibold text-[#00698F] text-lg">
          Selecciona un servicio
        </span>
      </div>

      {/* CONTENIDO */}
      <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* SELECT SERVICIO */}
        <div>
          <label className="text-sm font-semibold text-[#00698F] mb-1 block">
            Servicio <span className="text-red-500">*</span>
          </label>
          <Select
            isSearchable={false}
            options={opcionesServicios}
            value={form.servicio}
            onChange={handleServicio}
            placeholder="Selecciona un servicio"
            classNamePrefix="rs"
            styles={selectStyles}
            menuPortalTarget={document.body}
          />
          {errorServicio && (
            <p className="text-sm text-red-500 mt-1">{errorServicio}</p>
          )}
        </div>

        {/* SELECT VARIANTE */}
        <div>
          <label className="text-sm font-semibold text-[#00698F] mb-1 block">
            Variante <span className="text-red-500">*</span>
          </label>

          <Select
            isSearchable={false}
            options={opcionesVariantesUX}
            value={form.variante}
            onChange={handleVariante}
            placeholder="Selecciona una variante"
            classNamePrefix="rs"
            styles={selectStyles}
            menuPortalTarget={document.body}
            isDisabled={!!planEntrada}
          />
        </div>

          {/* MODALIDAD */}
          {form.variante && (
            (() => {
              if (planEntrada) {
                return (
                  <div className="md:col-span-2 mt-3">
                    <label className="text-sm font-semibold text-[#00698F] mb-2 block">
                      Modalidad Kinesiología
                    </label>

                    <div className="px-4 py-2 rounded-xl bg-[#00698F] text-white inline-block">
                      {(planEntrada.modalidad || "").toLowerCase().includes("gru")
                        ? "Grupal"
                        : "Privada"}{" "}
                      (desde plan)
                    </div>

                    <p className="text-xs text-[#00698F] mt-2">
                      Tu plan ya define la modalidad. No es posible cambiarla.
                    </p>
                  </div>
                );
              }

              const precios = {
                grupo:
                  typeof form.variante?.data?.precio_grupo === "number"
                    ? form.variante.data.precio_grupo
                    : 0,
                privada:
                  typeof form.variante?.data?.precio_privada === "number"
                    ? form.variante.data.precio_privada
                    : null,
              };

              return (

              <div className="md:col-span-2 mt-3">

              <label className="text-sm font-semibold text-[#00698F] mb-2 block">

              Modalidad

              </label>

                {permitePrivada && permiteGrupal ? (

                <div className="flex gap-4 flex-wrap">

                <button
                type="button"

                onClick={() => {

                setPrimarySlot?.(null);
                setModalidadKine("privada");

                setForm(prev => ({

                ...prev,

                hora: null,
                bloqueSeleccionado: null,

                }));

                }}

                className={`px-4 py-2 rounded-xl border font-medium transition

                ${modalidadKine==="privada"

                ? "bg-[#00698F] text-white border-blue-700"

                : "bg-white border-gray-300 text-gray-700"

                }`}

                >

                Privada (

                {(
                form.variante?.data?.precio_privada > 0

                ? form.variante.data.precio_privada

                : form.variante?.data?.precio

                )

                ? `$${(
                form.variante?.data?.precio_privada > 0

                ? form.variante.data.precio_privada

                : form.variante?.data?.precio

                ).toLocaleString("es-CL")}`

                : "—"}

                )

                </button>


                <button
                type="button"

                onClick={() => {

                setPrimarySlot?.(null);
                setModalidadKine("grupal");

                setForm(prev => ({

                ...prev,

                hora: null,
                bloqueSeleccionado: null,

                }));

                }}

                className={`px-4 py-2 rounded-xl border font-medium transition

                ${modalidadKine==="grupal"

                ? "bg-[#00698F] text-white border-blue-700"

                : "bg-white border-gray-300 text-gray-700"

                }`}

                >

                Grupal (

                {(
                form.variante?.data?.precio_grupo > 0

                ? form.variante.data.precio_grupo

                : form.variante?.data?.precio

                )

                ? `$${(
                form.variante?.data?.precio_grupo > 0

                ? form.variante.data.precio_grupo

                : form.variante?.data?.precio

                ).toLocaleString("es-CL")}`

                : "—"}

                )

                </button>

                </div>

                ) : (

                <div className="px-4 py-2 rounded-xl bg-[#00698F] text-white inline-block">

                {permitePrivada
                ? "Privada"
                : "Grupal"}

                {" ("}

                $

                {(
                permitePrivada

                ? (
                form.variante?.data?.precio_privada > 0

                ? form.variante.data.precio_privada

                : form.variante?.data?.precio

                )

                : (

                form.variante?.data?.precio_grupo > 0

                ? form.variante.data.precio_grupo

                : form.variante?.data?.precio

                )

                ).toLocaleString("es-CL")}

                )

                </div>

                )}

                <p className="text-xs text-gray-500 mt-2">

                {permitePrivada && permiteGrupal

                ? "Selecciona la modalidad en la que deseas reservar."

                : "Esta variante solo está disponible en esta modalidad."

                }

                </p>

              </div>

              )
            })()
          )}
      </div>
    </div>
  );
}
